export default __webpack_public_path__ + "static/media/christine.0810ff47.jpg";